<script>
import QueryIdentityField from './QueryIdentity.field.vue';

export default {
    extends: QueryIdentityField,
    props: {
        fieldName: {
            type: String,
            default: 'scov_hsp_perc',
        },
    },
};
</script>
